<script>
import { mapActions } from 'vuex';
import { cloneDeep, result } from 'lodash';
import RbxRemoteCombobox from '@/shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '@/shared/reybex/RbxRemoteComboboxMultiple';
import validatorMixin from '@/mixins/validator';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'MeasureDialog',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
  },
  mixins: [snackbarMixin, validatorMixin],
  props: {
    measureItem: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      visible: false,
      isLoading: false,
      rules: {
        name: { required: true },
      },
      baseFormData: {},
      formData: {},
      localDisabled: false,
    };
  },
  created() {
    this.formData = Object.assign({}, {}, this.measureItem);
    this.localDisabled = this.disabled;
  },
  mounted() {
    this.visible = true;
  },
  beforeDestroy() {
    this.visible = false;
  },
  methods: {
    ...mapActions('privacyAuditDetails', ['saveMeasure']),
    submit(type) {
      if (!this.validateForm()) return false;

      this.isLoading = true;

      return this.saveMeasure(this.formData)
        .then(({ data }) => {
          this.showSuccessMessage('Die Maßnahme wurde aktualisiert.');

          if (type === 'new') {
            this.formData = cloneDeep(this.baseFormData);
          } else {
            this.close();

            if (type === 'detail') {
              this.$router.push(`/measure/${data.id}`);
            }
          }
          this.$emit('update');
        })
        .catch(({ response }) => {
          const message = result(response, 'data.data.error', 'Es ist ein Fehler aufgetreten.');
          this.showErrorMessage(message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    close() {
      this.visible = false;
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <v-dialog v-model="visible"
            persistent
            max-width="1000px">

    <v-card>
      <v-card-title class="title pa-3">
        Maßnahme bearbeiten
        <v-spacer/>
        <v-btn @click="close" fab small flat>
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex md12>
              <v-layout row wrap>
                <v-flex md5>
                  <v-textarea
                    v-model="formData.name"
                    label="Bezeichnung"
                    class="caption"
                    readonly
                  />
                </v-flex>

                <v-flex md7>
                  <v-textarea
                    v-model="formData.description"
                    label="Beschreibung"
                    class="caption"
                    readonly
                  />
                </v-flex>
              </v-layout>

              <v-flex md5>
                <rbx-remote-combobox
                  v-model="formData.user"
                  :selected="formData.user"
                  searchable
                  clearable
                  domain="User"
                  label="Benutzer" />
              </v-flex>
            </v-flex>
            <v-flex md12/>
            <v-flex md12>
              <v-textarea
                v-model="formData.currentImplementation"
                :error-messages="validationErrorMessages.name"
                label="Aktuelle Umsetzung"
                height="44"
                class="caption"
              />
            </v-flex>
            <v-flex md12/>
            <v-flex md12>
              <v-textarea
                v-model="formData.plannedImplementation"
                :error-messages="validationErrorMessages.name"
                label="Geplante Umsetzung"
                height="44"
                class="caption"
              />
            </v-flex>
            <v-flex md12/>
            <v-flex md12>
              <v-textarea
                v-model="formData.pastImplementation"
                :error-messages="validationErrorMessages.name"
                label="Vergangene Umsetzung"
                height="44"
                class="caption"
              />
            </v-flex>
            <v-flex md12/>
            <v-flex md12>
              <v-textarea
                v-model="formData.note"
                :error-messages="validationErrorMessages.name"
                label="Notizen"
                height="44"
                class="caption"
              />
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn @click.native="close"
               color="red"
               flat>
          Schließen
        </v-btn>
        <v-btn @click.native="submit"
               color="blue"
               :loading="isLoading"
               flat>
          Speichern
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
